import React, {useState} from "react";
import Link from "next/link";

const Weddings: React.FC = ({ children }) => {


  return(
    <>
<section id="venue-hero">
      <div className="cover-shape"></div>
      <div className="content-container maxw1350">
        <h1>TacBoard for Reunions</h1>
        <p>Seamless collect and share old photos from the past as well as new one from the reunion.</p>
        <Link href="/tacboard-pricing">
            <a className="get-tac-now">Get TacBoard Now</a>
        </Link>
      </div>
      <div className="bottom-wave"></div>
    </section>

<section className="events-description">
  <div className="content-container">
    <h2>Set up TacBoard for your reunion and easily collect old photos from classmates all in one place before your event, then have them streaming at the reunion. Guests will absolutely love seeing all the pics from the past that they never knew existed. </h2>
  </div>
</section>

<section className="includes bg-cream e-cream">
      <h2 className="center">
        <span className="line"></span>Seamless Collaboration<span className="line"></span>
      </h2>
      <div className="flex-container">
        <div className="half">
        <picture>
            {/* <source type="image/webp" srcSet="
                img/text01dx1.webp,
                img/text01dx1.webp 2x
              " media="(min-width: 801px)" />
            <source type="image/webp" srcSet="
                img/text01mx1.webp,
                img/text01mx1.webp 2x
              " media="(max-width: 800px)" />

            <source type="image/jpf" srcSet="
                img/text01dx1.jpf,
                img/text01dx1.jpf 2x
              " media="(min-width: 801px)" />
            <source type="image/jpf" srcSet="
                img/text01mx1.jpf,
                img/text01mx1.jpf 2x
              " media="(max-width: 800px)" />

            <source type="image/jpg" srcSet="
                img/text01dx1.jpg,
                img/text01dx2.jpg 2x
              " media="(min-width: 801px)" />
            <source type="image/jpg" srcSet="
                img/text01mx1.jpg,
                img/text01mx2.jpg 2x
              " media="(max-width: 800px)" /> */}

            <img src="img/events-reunion-old.png" alt="TacBoard Corporate Events Signs" />
          </picture>
        </div>
        <div className="half">
          <p>
          Simply share your TacBoard phone number with guests beforehand and they can effortlessly text in pics of old photos they have, allowing you to easily collect hundreds of photos in one place.
          </p>
        </div>
      </div>
      <div className="top-wave"></div>
      <div className="bottom-wave"></div>
    </section>

    <section className="includes">
      <h2 className="center">
        <span className="line"></span>Start the party off right<span className="line"></span>
      </h2>
      <div className="flex-container row-reverse">
        <div className="half">
        <picture>
            {/* <source type="image/webp" srcSet="
                img/text01dx1.webp,
                img/text01dx1.webp 2x
              " media="(min-width: 801px)" />
            <source type="image/webp" srcSet="
                img/text01mx1.webp,
                img/text01mx1.webp 2x
              " media="(max-width: 800px)" />

            <source type="image/jpf" srcSet="
                img/text01dx1.jpf,
                img/text01dx1.jpf 2x
              " media="(min-width: 801px)" />
            <source type="image/jpf" srcSet="
                img/text01mx1.jpf,
                img/text01mx1.jpf 2x
              " media="(max-width: 800px)" />

            <source type="image/jpg" srcSet="
                img/text01dx1.jpg,
                img/text01dx2.jpg 2x
              " media="(min-width: 801px)" />
            <source type="image/jpg" srcSet="
                img/text01mx1.jpg,
                img/text01mx2.jpg 2x
              " media="(max-width: 800px)" /> */}

            <img src="img/events-reunion-old-2.png" alt="TacBoard Corporate Events Signs" />
          </picture>
        </div>
        <div className="half">       
        <p>
        Have old photos already streaming on your TacBoard Live Stream when the party starts. 
          </p>
        </div>
      </div>
    </section>


    <section className="includes bg-cream e-cream">
      <h2 className="center">
        <span className="line"></span>Ask and You Shall Receive<span className="line"></span>
      </h2>
      <div className="flex-container">
        <div className="half">
        <picture>
            {/* <source type="image/webp" srcSet="
                img/text01dx1.webp,
                img/text01dx1.webp 2x
              " media="(min-width: 801px)" />
            <source type="image/webp" srcSet="
                img/text01mx1.webp,
                img/text01mx1.webp 2x
              " media="(max-width: 800px)" />

            <source type="image/jpf" srcSet="
                img/text01dx1.jpf,
                img/text01dx1.jpf 2x
              " media="(min-width: 801px)" />
            <source type="image/jpf" srcSet="
                img/text01mx1.jpf,
                img/text01mx1.jpf 2x
              " media="(max-width: 800px)" />

            <source type="image/jpg" srcSet="
                img/text01dx1.jpg,
                img/text01dx2.jpg 2x
              " media="(min-width: 801px)" />
            <source type="image/jpg" srcSet="
                img/text01mx1.jpg,
                img/text01mx2.jpg 2x
              " media="(max-width: 800px)" /> */}

            <img src="img/events-corp-sign.png" alt="TacBoard Reunions Signs" />
          </picture>
          
        </div>
        <div className="half">      
        <p>
        Place some signs around at the event space asking guests to take selfies and text them to your TacBoard number. 
          </p>
        </div>
      </div>
      <div className="top-wave"></div>
      <div className="bottom-wave"></div>
    </section>

<section className="includes">
      <h2 className="center">
        <span className="line"></span>Make Photo Fun<span className="line"></span>
      </h2>
      <div className="flex-container row-reverse">
        <div className="half">
        <picture>
            {/* <source type="image/webp" srcSet="
                img/text01dx1.webp,
                img/text01dx1.webp 2x
              " media="(min-width: 801px)" />
            <source type="image/webp" srcSet="
                img/text01mx1.webp,
                img/text01mx1.webp 2x
              " media="(max-width: 800px)" />

            <source type="image/jpf" srcSet="
                img/text01dx1.jpf,
                img/text01dx1.jpf 2x
              " media="(min-width: 801px)" />
            <source type="image/jpf" srcSet="
                img/text01mx1.jpf,
                img/text01mx1.jpf 2x
              " media="(max-width: 800px)" />

            <source type="image/jpg" srcSet="
                img/text01dx1.jpg,
                img/text01dx2.jpg 2x
              " media="(min-width: 801px)" />
            <source type="image/jpg" srcSet="
                img/text01mx1.jpg,
                img/text01mx2.jpg 2x
              " media="(max-width: 800px)" /> */}

            <img src="img/events-weddings-photo-area.png" alt="TacBoard Reunions Photo Sign" />
          </picture>
        </div>
        <div className="half">
          <p>
          Make a photo station with fun props and a sign asking guests to snap some fun pics and text them to your TacBoard phone number.
          </p>
        </div>
      </div>
    </section>

    <section className="includes bg-cream e-cream">
      <h2 className="center">
        <span className="line"></span>A blast form the past<span className="line"></span>
      </h2>
      <div className="flex-container">
        <div className="half">
        <picture>
            {/* <source type="image/webp" srcSet="
                img/text01dx1.webp,
                img/text01dx1.webp 2x
              " media="(min-width: 801px)" />
            <source type="image/webp" srcSet="
                img/text01mx1.webp,
                img/text01mx1.webp 2x
              " media="(max-width: 800px)" />

            <source type="image/jpf" srcSet="
                img/text01dx1.jpf,
                img/text01dx1.jpf 2x
              " media="(min-width: 801px)" />
            <source type="image/jpf" srcSet="
                img/text01mx1.jpf,
                img/text01mx1.jpf 2x
              " media="(max-width: 800px)" />

            <source type="image/jpg" srcSet="
                img/text01dx1.jpg,
                img/text01dx2.jpg 2x
              " media="(min-width: 801px)" />
            <source type="image/jpg" srcSet="
                img/text01mx1.jpg,
                img/text01mx2.jpg 2x
              " media="(max-width: 800px)" /> */}

            <img src="img/events-reunion-old-3.png" alt="TacBoard Corporate Events Signs" />
          </picture>
        </div>
        <div className="half">
          <p>
          Your guests will absolutely love seeing all the old photos shared by other guests that they never even knew existed. It is a wonderful, fun and joyous experience.
          </p>
        </div>
      </div>
      <div className="top-wave"></div>
      <div className="bottom-wave"></div>
    </section>

<section className="includes">
      <h2 className="center">
        <span className="line"></span>For Everyones' Enjoyment<span className="line"></span>
      </h2>
      <div className="flex-container row-reverse">
        <div className="half">
        <picture>
            {/* <source type="image/webp" srcSet="img/sign-shop-sign-selfie-station.webp
                        " />
            <source type="image/jpg" srcSet="img/sign-shop-sign-selfie-station.jpg
                    " /> */}

            <img src="img/events-corp-gallery.png" alt="TacBoard Reunion Photo Gallery" />
          </picture>
        </div>
        <div className="half">
          <p>
          Additionally, you can seamlessly collect hundreds of photos from the reunion, all in one place for everyone to enjoy browsing after the reunion.
          </p>
        </div>
      </div>
    </section>

    <section className="includes bg-cream e-cream">
      <h2 className="center">
        <span className="line"></span>Everyone's Included<span className="line"></span>
      </h2>
      <div className="flex-container">
        <div className="half">
        <picture>
            {/* <source type="image/webp" srcSet="img/sign-shop-sign-selfie-station.webp
                        " />
            <source type="image/jpg" srcSet="img/sign-shop-sign-selfie-station.jpg
                    " /> */}

            <img src="img/events-reunion-remote.png" alt="TacBoard Reunion Photo Gallery" />
          </picture>
        </div>
        <div className="half">
          <p>
          Guests that can attend the reunion in person will be able to view your TacBoard Live Stream as well as send in their own photos from anywhere in the country. 
          </p>
        </div>
      </div>
      <div className="top-wave"></div>
      <div className="bottom-wave"></div>
    </section>

<section className="events-description">
  <div className="content-container">
    <h2>Sign up and get TacBoard for your your reunion!</h2>
  </div>
</section>

    </>
)}

export default Weddings;
